import { render } from "./VideoConsultationInfo.vue?vue&type=template&id=f6f52ed0&ts=true"
import script from "./VideoConsultationInfo.vue?vue&type=script&lang=ts"
export * from "./VideoConsultationInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__